import React from 'react';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';

export function DashboardSpinner() {
  return (
    <div className="d-flex justify-content-center py-3">
      <Spinner size={48} thickness={1} className="justify-content-center align-middle" />
    </div>
  );
}
